import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

// 默认佣金配置
const defaultConfig = [
  { id: 1, name: '七彩故事工坊', productId: '991716', price: 298, cost: 0, personal: 30, certified: 40, agency: 50 },
  { id: 2, name: '博文识读课程', productId: '20', price: 59, cost: 0, personal: 30, certified: 40, agency: 50 },
  { id: 3, name: '绘本创作工坊', productId: '21', price: 199, cost: 0, personal: 30, certified: 40, agency: 50 },
  { id: 4, name: '创意影像制作', productId: '991715', price: 19.9, cost: 0, personal: 30, certified: 40, agency: 50 },
  { id: 5, name: '创意影像10次套餐', productId: '366342', price: 99, cost: 0, personal: 30, certified: 40, agency: 50 },
  { id: 6, name: '创意影像30次套餐', productId: '791648', price: 259, cost: 0, personal: 30, certified: 40, agency: 50 },
  { id: 7, name: 'AI创作会员', productId: 'ON01', price: 99, cost: 10, personal: 60, certified: 80, agency: 80 },
]

export default function SalesCommissionConfig() {
  const [config, setConfig] = useState(defaultConfig)
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)

  const handleSave = async () => {
    setSaving(true)
    try {
      const res = await fetch(`${API}/commission-config`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ products: config })
      })
      if (res.ok) {
        setSaved(true)
        setTimeout(() => setSaved(false), 2000)
      }
    } catch (e) {
      console.error('保存失败', e)
    }
    setSaving(false)
  }

  const updateConfig = (id, field, value) => {
    setConfig(config.map(c => c.id === id ? { ...c, [field]: value } : c))
  }

  const calculateProfit = (c) => {
    const personalProfit = c.price - (c.price * c.personal / 100) - c.cost
    const certifiedProfit = c.price - (c.price * c.certified / 100) - c.cost
    const agencyProfit = c.price - (c.price * c.agency / 100) - c.cost
    return { personalProfit, certifiedProfit, agencyProfit }
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, margin: 0 }}>💰 佣金配置</h2>
        <button 
          onClick={handleSave} 
          disabled={saving}
          style={{ 
            padding: '10px 24px', 
            background: saved ? '#52c41a' : saving ? '#d9d9d9' : '#1890ff', 
            color: '#fff', 
            border: 'none', 
            borderRadius: 6, 
            cursor: saving ? 'not-allowed' : 'pointer',
            fontSize: 14
          }}
        >
          {saved ? '✓ 已保存' : saving ? '保存中...' : '保存配置'}
        </button>
      </div>

      {/* 说明 */}
      <div style={{ background: '#e6f7ff', border: '1px solid #91d5ff', borderRadius: 8, padding: 16, marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#1890ff', marginBottom: 8 }}>📋 佣金配置说明</div>
        <div style={{ fontSize: 13, color: '#666' }}>
          <p style={{ margin: '0 0 8px' }}>• <strong>个人推广员</strong>：免费注册，享较低佣金比例，无系统权限，不能招募下线</p>
          <p style={{ margin: '0 0 8px' }}>• <strong>认证推广员</strong>：¥5,000/年，享高佣金+系统权限，可招募下线拿管理奖</p>
          <p style={{ margin: '0 0 8px' }}>• <strong>机构推广合伙人</strong>：¥5,000/年，享高佣金+系统权限+线下活动利润100%</p>
          <p style={{ margin: 0 }}>• <strong>招募奖励</strong>：招募个人推广员，奖励¥100/人 + 下线佣金20%管理奖</p>
        </div>
      </div>

      {/* 佣金配置表 */}
      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={{ padding: '12px 8px', textAlign: 'left', fontSize: 12, color: '#666', width: 160 }}>产品</th>
              <th style={{ padding: '12px 8px', textAlign: 'right', fontSize: 12, color: '#666', width: 60 }}>售价</th>
              <th style={{ padding: '12px 8px', textAlign: 'right', fontSize: 12, color: '#666', width: 60 }}>成本</th>
              <th style={{ padding: '12px 8px', textAlign: 'center', fontSize: 12, color: '#13c2c2', width: 60 }}>个人<br/>推广</th>
              <th style={{ padding: '12px 8px', textAlign: 'center', fontSize: 12, color: '#722ed1', width: 60 }}>认证<br/>推广</th>
              <th style={{ padding: '12px 8px', textAlign: 'center', fontSize: 12, color: '#fa8c16', width: 60 }}>机构<br/>合伙</th>
              <th style={{ padding: '12px 8px', textAlign: 'right', fontSize: 12, color: '#52c41a', width: 200 }}>总部实得(认证/机构)</th>
            </tr>
          </thead>
          <tbody>
            {config.map(c => {
              const profit = calculateProfit(c)
              return (
                <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '12px 8px', fontWeight: 500 }}>{c.name}</td>
                  <td style={{ padding: '12px 8px', textAlign: 'right', color: '#f5222d' }}>¥{c.price}</td>
                  <td style={{ padding: '12px 8px', textAlign: 'right', color: '#999' }}>¥{c.cost}</td>
                  <td style={{ padding: '8px' }}>
                    <input 
                      type="number" 
                      value={c.personal} 
                      onChange={e => updateConfig(c.id, 'personal', parseInt(e.target.value) || 0)}
                      style={{ width: 50, padding: '4px 8px', border: '1px solid #d9d9d9', borderRadius: 4, textAlign: 'center', fontSize: 13 }}
                    />
                    <div style={{ fontSize: 11, color: '#999', marginTop: 2 }}>%</div>
                  </td>
                  <td style={{ padding: '8px' }}>
                    <input 
                      type="number" 
                      value={c.certified} 
                      onChange={e => updateConfig(c.id, 'certified', parseInt(e.target.value) || 0)}
                      style={{ width: 50, padding: '4px 8px', border: '1px solid #d9d9d9', borderRadius: 4, textAlign: 'center', fontSize: 13 }}
                    />
                    <div style={{ fontSize: 11, color: '#999', marginTop: 2 }}>%</div>
                  </td>
                  <td style={{ padding: '8px' }}>
                    <input 
                      type="number" 
                      value={c.agency} 
                      onChange={e => updateConfig(c.id, 'agency', parseInt(e.target.value) || 0)}
                      style={{ width: 50, padding: '4px 8px', border: '1px solid #d9d9d9', borderRadius: 4, textAlign: 'center', fontSize: 13 }}
                    />
                    <div style={{ fontSize: 11, color: '#999', marginTop: 2 }}>%</div>
                  </td>
                  <td style={{ padding: '12px 8px', textAlign: 'right' }}>
                    <span style={{ color: profit.certifiedProfit >= 0 ? '#52c41a' : '#f5222d', fontWeight: 500 }}>
                      ¥{profit.certifiedProfit.toFixed(0)}
                    </span>
                    <span style={{ color: '#999', margin: '0 4px' }}>/</span>
                    <span style={{ color: profit.agencyProfit >= 0 ? '#52c41a' : '#f5222d', fontWeight: 500 }}>
                      ¥{profit.agencyProfit.toFixed(0)}
                    </span>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      {/* 招募奖励配置 */}
      <div style={{ background: '#fff', borderRadius: 8, padding: 24, marginTop: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>🎁 招募奖励配置</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 24 }}>
          <div>
            <label style={{ display: 'block', fontSize: 13, color: '#666', marginBottom: 8 }}>招募个人推广员奖励</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ color: '#f5222d', fontSize: 24, fontWeight: 600 }}>¥100</span>
              <span style={{ color: '#999', marginLeft: 8 }}>/人</span>
            </div>
            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>认证/机构推广合伙人招募下线时奖励</div>
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 13, color: '#666', marginBottom: 8 }}>下线管理奖比例</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ color: '#722ed1', fontSize: 24, fontWeight: 600 }}>20%</span>
              <span style={{ color: '#999', marginLeft: 8 }}>佣金提成</span>
            </div>
            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>下线产生佣金时，上线获得的比例奖励</div>
          </div>
        </div>
      </div>
    </div>
  )
}
